import { AxiosError } from "axios";
import { showNotification } from "../../common/actionCreators/dispatchNotification";
import apiClient from "../../common/api/apiClient";
import { ApiError } from "../../common/api/apiResponse";
import { ExhibitDto } from "./exhibits.dtos";

const exhibitsUrl = '/exhibits/';

export const getExhibitsApi = async () => {
    return await apiClient.get(exhibitsUrl)
    .then((res) => {
        return res.data.result;
    })
    .catch((err) => {
        console.log('In error', err);
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            console.log("response: ", axiosError.response)
            showNotification(axiosError.response?.data?.error?.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while retrieving exhibits.', 'error');
        }
        throw err;
    });
};

export const getExhibitApi = async (request: string) => {
    return await apiClient.get(exhibitsUrl + request)
    .then((res) => {
        return res.data.result;
    })
    .catch((err) => {
        console.log('In error', err);
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            console.log("response: ", axiosError.response)
            showNotification(axiosError.response?.data?.error?.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while retrieving exhibit.', 'error');
        }
        throw err;
    });
};

export const updateExhibitApi = async (request: ExhibitDto) => {
    const data = new FormData();
  
    if (request.fileUpload && request.fileUpload.length > 0) {
      request.fileUpload.forEach(file => data.append("file", file));
    }
  
    data.append("model", JSON.stringify(request));
    
    return await apiClient.put(exhibitsUrl, data)
      .then((res) => {
        showNotification("Exhibit updated", 'success');
        return res.data.result;
      })
      .catch((err) => {
        console.log('In error', err);
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            showNotification(axiosError.response.data.error.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while updating exhibit.', 'error');
        }
        throw err;
      });
};

export const createExhibitApi = async (request: ExhibitDto) => {
    const data = new FormData();
    
    if (request.fileUpload && request.fileUpload.length > 0) {
      request.fileUpload.forEach(file => data.append("file", file));
    }

    data.append("model", JSON.stringify(request));

    return await apiClient.post(exhibitsUrl, data)
      .then((res) => {
        showNotification("Exhibit created", 'success');
        return res.data.result;
      })
      .catch((err) => {
        console.log('In error', err);
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            showNotification(axiosError.response.data.error.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while creating exhibit.', 'error');
        }
        throw err;
      });
};

export const deleteThumbnailApi = async (id: string, fileName: string) => {
  return await apiClient.delete(`${exhibitsUrl}thumbnail/${id}/${fileName}`)
  .then((res) => {
    showNotification("Thumbnail deleted", 'success');
    return res.data.result;
  })
  .catch((err) => {
    if (err && err.response) {
      const axiosError = err as AxiosError<ApiError>;
      if (axiosError.response) {
        showNotification(axiosError.response.data.error.message, 'error');
      }
    }
    else {
      showNotification('An error occurred while deleting image.', 'error');
    }
    throw err;
  });
}

export const uploadContentImageApi = async (request: File) => {
  
  const data = new FormData();
  data.append('file', request);
  return await apiClient.post(`${exhibitsUrl}upload`, data)
  .then((res) => {
    return res.data;
  })
  .catch((err) => {
    if (err && err.response) {
      const axiosError = err as AxiosError<ApiError>;
      if (axiosError.response) {
        showNotification(axiosError.response.data.error.message, 'error');
      }
    }
    else {
      showNotification('An error occurred while uploading image.', 'error');
    }
    throw err;
  });
}